<template>
  <div class="dialog-edit-vessel-document">
    <vs-prompt
      @accept="updateVesselDocument"
      @cancel="cancel"
      @close="close"
      :active.sync="showDialog"
      :title="title"
      :accept-text="acceptText"
      :cancel-text="cancelText"
      :is-valid="validateForm"
    >
      <div>
        <span>書類名</span>
        <vs-input
          v-model="vesselDocumentRequest.document_name"
          class="w-full"
          v-validate="'required|max:32'"
          name="name"
          data-vv-as="書類名"
        />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{
          errors.first("name")
        }}</span>
        <br />
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import _ from "lodash";
import { createNamespacedHelpers } from "vuex";

const { mapActions } = createNamespacedHelpers("enterpriseVesselView");

export default {
  components: {},
  data() {
    return {
      vesselId: null,
      vesselDocument: null,
      vesselDocumentRequest: {
        delivery_date: null,
        document_name: null,
        expired_date: null,
        picture_id: null
      },
      error: { message: null },
      showDialog: false,
      title: "編集",
      acceptText: "変更",
      cancelText: "キャンセル",
      isValid: true
    };
  },
  computed: {
    validateForm() {
      return (
        this.required() && !this.isSameName() && !this.errors.any()
      );
    }
  },
  methods: {
    ...mapActions(["updateDocument"]),

    show(vesselId, vesselDocument) {
      this.vesselDocument = _.cloneDeep(vesselDocument);
      this.vesselId = vesselId;
      this.vesselDocumentRequest.document_name = this.vesselDocument.document_name;
      this.vesselDocumentRequest.picture_id = this.vesselDocument.picture.id;
      this.showDialog = true;
    },

    required(){
      return this.vesselDocumentRequest.document_name !== null
    },

    isSameName(){
      return this.vesselDocumentRequest.document_name === this.vesselDocument.document_name
    },

    async updateVesselDocument() {
      this.$vs.loading();
      let payload = {
        vesselId: this.vesselId,
        linkId: this.vesselDocument.id,
        request: this.vesselDocumentRequest
      };
      try {
        await this.updateDocument(payload);
        this.$vs.loading.close();
        this.$vs.notify({
          title:
            "船舶書類の名前を変更しました",
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        });
        this.$emit("onUpdate");
        this.close();
      } catch (e) {
        this.$vs.notify({
          title: "船舶書類の登録に失敗しました",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
        this.$vs.loading.close();
        this.close();
      }
    },

    close() {
      this.cleanUp();
    },

    cancel() {
      this.cleanUp();
    },

    cleanUp() {
      this.showDialog = false;
    }
  }
};
</script>

<style lang="scss"></style>
